export enum ControlType {
  BOOLEAN = 0,
  RADIO = 1,
  MULTI = 2,
  TEXT = 3,
  INTEGER = 4,
  DECIMAL = 5,
  DEVICES = 6,
  DROPDOWN = 7,
  DATETIME = 8
  // TIMESTAMP = 12
  // 8 used by DATETIME, 9 for DURATION
  // 10 EXPRESSION, 11 PICTURE
}

export class DropdownValue{
  title: string;
  value: string;
}

export class FormValue{
  formFieldType: ControlType;
  base64JsonValue: string;


  constructor(formFieldType: ControlType, base64JsonValue: string) {
    this.formFieldType = formFieldType;
    this.base64JsonValue = base64JsonValue;
  }
}

export class FormItem {
  name: string;
  type: ControlType;
  renderTag: string;
  description: string;
  required: boolean;
  sort?: number;
  values?: string[];

  constructor(name?: string,
              type?: ControlType,
              tag?: string,
              description?: string,
              required?: boolean,
              sort?: number,
              values?: string[]) {
    this.name = name;
    this.type = type;
    this.renderTag = tag;
    this.description = description;
    this.required = required;
    this.sort = sort;
    this.values = values && [...values];
  }
}
